"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var MailOutline_1 = __importDefault(require("@mui/icons-material/MailOutline"));
var react_toastify_1 = require("react-toastify");
var trans_1 = __importDefault(require("@/plugins/trans"));
var helpers_1 = require("@/frontend/helpers");
var UserLight_1 = require("../models/UserLight");
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var UserContext_1 = __importDefault(require("../context/UserContext"));
var Switch_1 = __importDefault(require("../components/Switch"));
var classes = {
    main: {
        position: 'relative',
        backgroundColor: 'white',
        border: '1px solid #CDCDCD',
        borderRadius: '5px',
        overflow: 'hidden',
        p: '22px',
        display: 'grid',
        gap: 4,
        mt: 5,
    },
    badge: {
        height: '56px',
        width: '56px',
        backgroundColor: function (theme) { return theme.palette.primary.main; },
        borderRadius: '50%',
        position: 'absolute',
        top: '-8px',
        right: '-8px',
        display: 'grid',
        placeItems: 'center',
        '&>img': {
            width: '30px',
        },
    },
    title: {
        color: function (theme) { return theme.palette.secondary.main; },
        borderBottom: function (theme) { return "3px solid ".concat(theme.palette.primary.main); },
        width: 'max-content',
        fontWeight: 500,
    },
    label: {
        fontWeight: 500,
    },
    emailInput: {
        p: 0,
        flex: 1,
        '& .MuiOutlinedInput-input': {
            p: 2,
        },
        width: '100%',
        backgroundColor: '#F4F2F4',
    },
    switchBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
};
var VacancyAlert = function () {
    var geocoder = (0, react_1.useMemo)(function () { return new google.maps.Geocoder(); }, []);
    // Email control
    var _a = (0, react_1.useState)(''), email = _a[0], setEmail = _a[1];
    var _b = (0, react_1.useState)(null), userLight = _b[0], setUserLight = _b[1];
    // Switch control
    var _c = (0, react_1.useState)(false), checked = _c[0], setChecked = _c[1];
    var _d = (0, react_1.useState)(true), isSwitchDisabled = _d[0], setIsSwitchDisabled = _d[1];
    // * Used as data to remove vacancy if present
    var _e = (0, react_1.useState)(null), vacancyAlertId = _e[0], setVacancyAlertId = _e[1];
    // * Stores the current vacancy settings
    // * Used for finding vacancy alert
    var _f = (0, react_1.useState)({
        search_terms: '',
        location: null,
        distance: null,
    }), alertData = _f[0], setAlertData = _f[1];
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var query = (0, react_1.useContext)(SearchVacanciesContext_1.default).query;
    var fetchUserLight = function () {
        if (!userLight) {
            (0, UserLight_1.getUserLight)().then(function (_a) {
                var data = _a.data;
                setUserLight(data);
            });
        }
    };
    (0, react_1.useEffect)(function () {
        setIsSwitchDisabled(!userId && !userLight);
    }, [userId, userLight]);
    // This effect is executed every time the "what" (search_terms), "where" (location), and distance change.
    // It gets the data from the current URL and it checks whether there is a vacancy alert with
    // such settings already present for the auth user in the system.
    (0, react_1.useEffect)(function () {
        setIsSwitchDisabled(true);
        var requestData = {
            search_terms: query.search,
            location: null,
            distance: query.distance,
        };
        var handleAlertData = function (currentAlertData) {
            setAlertData(currentAlertData);
            // Find a vacancy alert with current settings.
            // If there is one, set the vacancy alert id.
            // Manipulate the checked property depending if there is a vacancy alert.
            axios_1.default.post('/vacancy-alerts/find', currentAlertData).then(function (_a) {
                var data = _a.data;
                var id = (data.vacancyAlert && data.vacancyAlert.id) || data.id;
                if (id) {
                    setVacancyAlertId(id);
                }
                setChecked(!!id);
                setIsSwitchDisabled(false);
                fetchUserLight();
            });
        };
        if (query.lat && query.lng) {
            geocoder.geocode({ location: { lat: query.lat, lng: query.lng } }).then(function (_a) {
                var results = _a.results;
                var location = results[0];
                if (location) {
                    requestData.location = location.place_id;
                }
                handleAlertData(requestData);
            });
        }
        else if (!!requestData.search_terms || requestData.location) {
            handleAlertData(requestData);
        }
    }, [query]);
    var handleSwitch = (0, react_1.useCallback)(function () {
        var isChecked = !checked;
        setIsSwitchDisabled(true);
        if (isChecked) {
            axios_1.default
                .post('/vacancy-alerts/create', __assign(__assign({}, alertData), { email: email }))
                .then(function (_a) {
                var data = _a.data;
                setVacancyAlertId(data.id);
                fetchUserLight();
                react_toastify_1.toast.success(data.message, {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                });
                setChecked(isChecked);
            })
                .catch(function (_a) {
                var data = _a.data;
                react_toastify_1.toast.error(data.message, {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                });
                setChecked(!isChecked);
            })
                .finally(function () {
                setIsSwitchDisabled(false);
            });
        }
        else {
            axios_1.default
                .delete("/vacancy-alerts/delete/".concat(vacancyAlertId))
                .then(function (_a) {
                var data = _a.data;
                setVacancyAlertId(null);
                react_toastify_1.toast.success(data.message, {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                });
                setChecked(isChecked);
            })
                .catch(function (_a) {
                var data = _a.data;
                react_toastify_1.toast.error(data.message, {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                });
                setChecked(!isChecked);
            })
                .finally(function () {
                setIsSwitchDisabled(false);
            });
        }
    }, [checked, alertData, vacancyAlertId, email]);
    var handleEmailInput = (0, react_1.useCallback)(function (e) {
        var value = e.target.value;
        localStorage.setItem('email', value);
        setIsSwitchDisabled(!(0, helpers_1.isEmail)(value));
        setEmail(value);
    }, []);
    if (!alertData.search_terms && !alertData.location) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.main }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: classes.badge }, { children: (0, jsx_runtime_1.jsx)(MailOutline_1.default, { fontSize: "large", sx: { color: 'white' } }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: classes.title }, { children: trans_1.default.get('labels.frontend.vacancy_alert.card.title') })), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: classes.label }, { children: trans_1.default.get('labels.frontend.vacancy_alert.card.email') })), (0, jsx_runtime_1.jsx)(material_1.TextField, { sx: classes.emailInput, hiddenLabel: true, placeholder: trans_1.default.get('columns.vacancy_alert.email_placeholder'), value: email, onChange: handleEmailInput })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.switchBox }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { color: '#4B4B4B' } }, { children: trans_1.default.get('labels.frontend.vacancy_alert.card.switch') })), (0, jsx_runtime_1.jsx)(Switch_1.default, { disabled: isSwitchDisabled, onClick: handleSwitch, checked: checked })] }))] })));
};
exports.default = VacancyAlert;
